import React, { useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { format } from "date-fns";

import * as APIDashboard from "../../../services/nps/functions";

import NpsEvolution from "./NpsEvolution/NpsEvolution";
import NpsLevel from "./NpsLevel/NpsLevel";
import NpsDateOne from "./NpsDateOne/NpsDateOne";
import NpsDateTwo from "./NpsDateTwo/NpsDateTwo";
import NpsDateThree from "./NpsDateThree/NpsDateThree";
import ClassificationZoneProfileMap from "./ClassificationZoneProfileMap/ClassificationZoneProfileMap";
import NpsDateFour from "./NpsDateFour/NpsDateFour";
import NpsDateFive from "./NpsDateFive/NpsDateFive";
import Negotiations from "./Negotiations/Negotiations";

import "./dashboard-agent.css";
import NpsZoneOfExcellence from "./NpsZoneOfExcellence";
import { getChannels } from "../../../actions";

export default function DashboardAgent() {
  const filtersDashboard = useSelector((state) => state.npsfilters);
  const cardsOfCallCenterDash = useSelector(
    (state) => state.cardsOfCallCenterDash
  );
  const [initialDate, setInitialDate] = useState(filtersDashboard.datestart);
  const [finalDate, setFinalDate] = useState(filtersDashboard.dateend);
  const [npsValue, setNpsValue] = useState(0);
  const [midias, setMidias] = useState([]);
  const [isLoadingSurveyInfos, setIsLoadingSurveyInfos] = useState(false);
  const [surveyInfosFromDateOne, setSurveyInfosFromDateOne] = useState({
    answered: "0",
    percentEvalueted: "0",
    sended: 0,
    percentSended: "0",
    evalueted: "0",
    finished: 0,
  });
  const [loadingPieChartData, setLoadingPieChartData] = useState(false);
  const [loadingFromDateOne, setLoadingFromDateOne] = useState(false);

  async function getAllMidias() {
    const response = await getChannels();

    if (response && response.status !== 200) return;

    if (response && response.status === 200) {
      setMidias(response.data);
    }
  }

  const hasNpsEvolution = cardsOfCallCenterDash.card1;
  const hasNpsLevel = cardsOfCallCenterDash.card2;
  const hasNpsDateOne =
    cardsOfCallCenterDash.card3 || cardsOfCallCenterDash.card4;
  const hasNpsDateTwo =
    cardsOfCallCenterDash.card5 || cardsOfCallCenterDash.card6;
  const hasNpsDateThree =
    cardsOfCallCenterDash.card7 || cardsOfCallCenterDash.card8;
  const hasNpsDateFour =
    cardsOfCallCenterDash.card9 || cardsOfCallCenterDash.card10;
  const hasNpsDateFive =
    cardsOfCallCenterDash.card11 || cardsOfCallCenterDash.card12;
  const hasNegotiations = cardsOfCallCenterDash.card13;

  /*
  useEffect(() => {
    getAllMidias();
  }, []);
*/
  return (
    <article className="nps-dashboard">
      {hasNpsEvolution && <NpsEvolution />}

      {hasNpsLevel && (
        <NpsLevel
          setLevel={setNpsValue}
          setLoadingPieChartData={setLoadingPieChartData}
        />
      )}

      <NpsZoneOfExcellence />

      {hasNpsDateOne && (
        <NpsDateOne
          setIsLoadingSurveyInfos={setIsLoadingSurveyInfos}
          setSurveyInfosFromDateOne={setSurveyInfosFromDateOne}
          setLoadingFromDateOne={setLoadingFromDateOne}
        />
      )}

      {hasNpsDateTwo && <NpsDateTwo />}

      {hasNpsDateThree && (
        <NpsDateThree
          npsValue={npsValue}
          surveyInfosFromDateOne={surveyInfosFromDateOne}
          loadingFromDateOne={loadingFromDateOne}
        />
      )}

      {hasNpsDateFour && <NpsDateFour />}

      {hasNpsDateFive && <NpsDateFive />}

      {hasNegotiations && <Negotiations />}
    </article>
  );
}
